(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artista-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-artista-techniques]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-technique-tab]');
    const panels = section.querySelectorAll('[data-technique-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.techniqueTab;

        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.techniquePanel !== selected;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
